export default function GetPageRoutes() {


    const whatsInEachAnalysisRoute = {
        path: '/property-intelligence/whats-in-each-analysis',
        label: "What's in the Analysis?"
    }

    const commonMisconceptionsRoute = {
        path: '/property-intelligence/common-misconceptions',
        label: 'Common Misconceptions'
    }

    const whatIsQuollRoute = {
        path: '/about/what-is-quoll',
        label: 'What is Quoll?'
    }

    const whyIsQuollFreeRoute = {
        path: '/about/why-is-quoll-free',
        label: 'Why is Quoll Free?'
    }

    const methodologyRoute = {
        path: '/about/methodology',
        label: 'Our Methodology'
    }

    const contactUsRoute = {
        path: '/contact-us',
        label: 'Contact Us'
    }

    const workWithUsRoute = {
        path: '/careers',
        label: 'Careers'
    }

    const resourcesRoute = {
        path: '/resources',
        label: 'Resources'
    }

    const privacyPolicyRoute = {
        path: '/privacy/privacy-policy',
        label: 'Privacy Policy'
    }

    const termsOfServiceRoute = {
        path: '/privacy/terms-and-conditions',
        label: 'Terms and Conditions'
    }

    const ccpaDataRequestRoute = {
        path: '/ccpa-data-request',
        label: 'CCPA Data Request'
    }

    const doNotSellRoute = {
        path: '/do-not-sell',
        label: 'Do Not Sell My Information'
    }

    const faqRoute = {
        path: '/about/faq',
        label: 'FAQ'
    }

    const siteMapRoute = {
        path: '/sitemap.xml',
        label: 'Site Map'
    }

    const headerRoutes = [
        {
            label: 'Home Analyses',
            subRoutes: [
                whatsInEachAnalysisRoute,
                commonMisconceptionsRoute,
                methodologyRoute,
            ]
        },
        {
            label: 'About Quoll',
            subRoutes: [
                whatIsQuollRoute,
                whyIsQuollFreeRoute,
                faqRoute,
                contactUsRoute,
                workWithUsRoute
            ]
        },
        resourcesRoute,
    ]

    const footerRoutes = [
        whatsInEachAnalysisRoute,
        commonMisconceptionsRoute,
        methodologyRoute,
        whatIsQuollRoute,
        whyIsQuollFreeRoute,
        workWithUsRoute,
        contactUsRoute,
        privacyPolicyRoute,
        termsOfServiceRoute,
        ccpaDataRequestRoute,
        doNotSellRoute,
        faqRoute,
        siteMapRoute
    ]

    const output = {
        header: headerRoutes,
        footer: footerRoutes
    }




    return output;
}